<template>
	<section
		class="container container--a module-margin"
		:class="'img-side-' + data.images_side + ' images-' + data.gallery_blocks.length"
	>
		<div class="inner">
			<div v-if="data.gallery_blocks && data.gallery_blocks.length < 3" class="gallery-images-standard">
				<a
					class="inner-gallery"
					:key="k"
					v-for="(image, k) in data.gallery_blocks"
					:data-fslightbox="'lightbox_' + shortId"
					:href="image.url"
				>
					<svg
						class="open-lightbox"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13.11 0a2.506 2.506 0 012.492 2.305l.008.195v5.405h-1.667V2.847L2.88 13.943h5.023v1.667H2.5a2.506 2.506 0 01-2.492-2.304L0 13.11V7.705h1.667v5.054L12.729 1.667H7.706V0h5.404z"
							fill="#FFF"
							fill-rule="evenodd"
						/>
					</svg>
					<!-- Render original HTML in server, render Swiper in browser (client) -->
					<WpImage
						cover
						:caption="data.gallery_blocks.length === 1"
						background
						size="medium_large"
						:image="image"
					/>
				</a>
			</div>
			<div v-else class="gallery-images-sided">
				<div class="main-image">
					<a
						class="inner-gallery"
						:data-fslightbox="'lightbox_' + shortId"
						:href="data.gallery_blocks[0].url"
					>
						<svg
							class="open-lightbox"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M13.11 0a2.506 2.506 0 012.492 2.305l.008.195v5.405h-1.667V2.847L2.88 13.943h5.023v1.667H2.5a2.506 2.506 0 01-2.492-2.304L0 13.11V7.705h1.667v5.054L12.729 1.667H7.706V0h5.404z"
								fill="#FFF"
								fill-rule="evenodd"
							/>
						</svg>
						<!-- Render original HTML in server, render Swiper in browser (client) -->
						<WpImage cover background size="medium_large" :image="data.gallery_blocks[0]" />
					</a>
				</div>
				<div class="side-images">
					<a
						class="inner-gallery"
						:data-fslightbox="'lightbox_' + shortId"
						:href="data.gallery_blocks[1].url"
					>
						<svg
							class="open-lightbox"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M13.11 0a2.506 2.506 0 012.492 2.305l.008.195v5.405h-1.667V2.847L2.88 13.943h5.023v1.667H2.5a2.506 2.506 0 01-2.492-2.304L0 13.11V7.705h1.667v5.054L12.729 1.667H7.706V0h5.404z"
								fill="#FFF"
								fill-rule="evenodd"
							/>
						</svg>
						<!-- Render original HTML in server, render Swiper in browser (client) -->
						<WpImage cover background size="medium_large" :image="data.gallery_blocks[1]" />
					</a>
					<a
						class="inner-gallery"
						:data-fslightbox="'lightbox_' + shortId"
						:href="data.gallery_blocks[2].url"
					>
						<svg
							class="open-lightbox"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M13.11 0a2.506 2.506 0 012.492 2.305l.008.195v5.405h-1.667V2.847L2.88 13.943h5.023v1.667H2.5a2.506 2.506 0 01-2.492-2.304L0 13.11V7.705h1.667v5.054L12.729 1.667H7.706V0h5.404z"
								fill="#FFF"
								fill-rule="evenodd"
							/>
						</svg>
						<!-- Render original HTML in server, render Swiper in browser (client) -->
						<WpImage cover background size="medium_large" :image="data.gallery_blocks[2]" />
					</a>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
require('fslightbox')

import shortid from 'shortid'
import WpImage from '@/components/elements/WpImage'

export default {
	name: 'gallery-blocks',
	props: ['data'],
	data() {
		return {
			showData: false,
			currentSlide: 0,
			shortId: shortid.generate(),
		}
	},
	computed: {},
	components: {
		WpImage,
	},
	directives: {},
	mounted() {
		refreshFsLightbox()
	},
	destroyed() {
		if (fsLightboxInstances['lightbox_' + this.shortId]) {
			delete fsLightboxInstances['lightbox_' + this.shortId]
		}
		// if(fsLightboxInstances['lightbox_server']){
		//   delete fsLightboxInstances['lightbox_server']
		// }
	},
	methods: {},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-gallery {
	&.images-1,
	&.images-2 {
		.inner-gallery {
			.wp-image-vue {
				.image {
					@include mquery($phone) {
						height: 250px !important;
					}
				}
			}
		}
	}

	&.img-side-right {
		.main-image {
			order: 1;
			margin-right: 0 !important;
		}
		.side-images {
			order: 0;
		}
	}
	&.img-side-left {
		.main-image {
			order: 0;
			@include mquery($phone) {
				margin-bottom: 25px;
			}
		}
		.side-images {
			margin-right: 0 !important;
			order: 1;
			@include mquery($phone) {
				a {
					margin-bottom: 0px !important;
				}
			}
		}
	}

	.gallery-images-sided {
		display: flex;
		@include mquery($phone) {
			flex-direction: column;
			.main-image {
				.wp-image-vue {
					div.image {
						@include mquery($tablet) {
							height: 250px !important;
						}
					}
				}
			}
		}

		.main-image,
		.side-images {
			flex: 1 1 0px;
			margin-right: 50px;
			@include mquery($tablet) {
				margin-right: 25px;
			}
			@include mquery($phone) {
				margin-right: 0px;
			}
		}
		.side-images {
			@include mquery($phone) {
				display: flex;
				a {
					width: 50%;
					&:first-child {
						padding-right: 12.5px;
					}
					&:last-child {
						padding-left: 12.5px;
					}
				}
			}
			.inner-gallery {
				&:first-child {
					margin-bottom: 50px;
					@include mquery($tablet) {
						margin-bottom: 25px;
					}
				}
			}
			.wp-image-vue {
				div.image {
					height: 268px !important;
					@include mquery($tablet) {
						height: 213px !important;
					}
				}
			}
		}
	}
	.gallery-images-standard {
		display: flex;
		.inner-gallery {
			flex: 1 1 0px;
			margin-right: 50px;
			@include mquery($tablet) {
				margin-right: 25px;
			}
			&:last-child {
				margin-right: 0;
			}
		}
	}
	.inner-gallery {
		position: relative;
		display: block;
		text-decoration: none;
		&:hover {
			.open-lightbox {
				opacity: 1;
			}
		}
		.open-lightbox {
			opacity: 0;
			display: block;
			position: absolute;
			top: 30px;
			right: 30px;
			z-index: 50;
			transition: opacity 0.15s ease-in-out;
			@include mquery($tablet) {
				top: 20px;
				right: 20px;
			}
		}
		.wp-image-vue {
			position: relative;
			z-index: 40;
			.image {
				padding: 0 !important;
				height: 586px !important;
				@include mquery($tablet) {
					height: 450px !important;
				}
			}
			figcaption {
				z-index: 10;
				max-width: $containerSmall;
				margin-left: auto;
				margin-right: auto;
				margin-top: 25px;
				@include fluid-type($smallResText, $wideResText, 12px, 16px);
				@include mquery($phone) {
					margin-top: 10px;
					margin-left: 10px;
					margin-right: 10px;
				}
			}
		}
	}
}
</style>
